import "./actor.cb50ae3a.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec1c4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec1c4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $6TXE3 = parcelRequire("6TXE3");
const $b7684762b8f80af6$var$game = new $6TXE3.Engine({
    width: 600,
    height: 400
});
// start-snippet{canvas}
const $b7684762b8f80af6$var$canvas = new $6TXE3.Canvas({
    width: 200,
    height: 200,
    cache: true,
    draw: (ctx)=>{
        console.log('With cache=true I draw once');
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, 200, 200);
    }
});
const $b7684762b8f80af6$var$actor = new $6TXE3.Actor({
    pos: $b7684762b8f80af6$var$game.screen.center
});
$b7684762b8f80af6$var$actor.graphics.use($b7684762b8f80af6$var$canvas);
// end-snippet{canvas}
$b7684762b8f80af6$var$game.start().then(()=>{
    $b7684762b8f80af6$var$game.currentScene.add($b7684762b8f80af6$var$actor);
});


//# sourceMappingURL=canvas.f50ad371.js.map
